import { unMask } from './removeMask';

export const validatePhone = (phone: string) => {
  return !!(unMask(phone).length === 11);
};
